export default "__VITE_ASSET__WPSbFTtR__"